<template>
	<div>
		<FlowTreeBlockDataProvider
			v-if="blockData"
			v-on="$listeners"
			class="mb-1"
			isFinalEndRunBlock
			:blockData="blockData"
			:isContextualBlock="false"
			@clickBlock="onEndRunClicked"
		/>
		<div
			v-else
			class="end-run-flag flex-centerize hover-btn-effect"
			:class="{ 'is-reachable': isEndRunReachable, 'is-loading': isEndRunLoading }"
			@click="onEndRunClicked"
		>
			<AppLoader v-if="isEndRunLoading" />
			<AppIcon v-else name="ply-end-flow-run"></AppIcon>
		</div>
	</div>
</template>

<script>
import FlowTreeBlockDataProvider from './FlowTreeBlockDataProvider';
import { isEndRunLoading } from '@/store/modules/treeBlocks/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
export default {
	name: 'EndRunTreeBlock',
	components: {
		FlowTreeBlockDataProvider,
	},
	props: {
		blockData: { type: Object },
		onEndRunClicked: { type: Function },
		isEndRunReachable: { type: Boolean, required: false },
	},
	computed: {
		...mapGettersShorthand({ isEndRunLoading }),
	},
};
</script>

<style scoped lang="scss">
.end-run-flag {
	padding: 15px 40px;
	border: 1px solid var(--button-border);
	border-radius: 8px;
	background-color: #ffffff;

	::v-deep(svg) {
		margin-top: 4px;
	}
}

.end-run-flag {
	&:not(.is-reachable) {
		opacity: 0.5;
		cursor: not-allowed !important;
	}
	&.is-loading {
		pointer-events: none;
		cursor: not-allowed !important;
	}
}
</style>
